import { render, staticRenderFns } from "./alertTable.vue?vue&type=template&id=30767fbe&scoped=true&"
import script from "./alertTable.vue?vue&type=script&lang=js&"
export * from "./alertTable.vue?vue&type=script&lang=js&"
import style0 from "./alertTable.vue?vue&type=style&index=0&id=30767fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30767fbe",
  null
  
)

export default component.exports